export const cropVariantsTranslatePaths: any = {
  crop_variants: {
    corn: 'crop_variants.corn',
    rapeseed: 'crop_variants.rapeseed',
    cabage: 'crop_variants.cabage',
    vine: 'crop_variants.vine',
    wheat: 'crop_variants.wheat',
  },
};
